module.exports = __webpack_public_path__ + "img/ch.f45a7db.svg";